import { Clock } from "lucide-react";
import { useRef, useState, useEffect } from "react";

const TimeRangePopover = ({
  mode = "draft",
  draftHourFrom,
  draftHourTo,
  onDraftChange,

  // modo apply
  hourFrom,
  hourTo,
  onApply,
}) => {
  const [open, setOpen] = useState(false);

  const [from, setFrom] = useState(
    mode === "draft" ? draftHourFrom || "" : hourFrom || ""
  );
  const [to, setTo] = useState(
    mode === "draft" ? draftHourTo || "" : hourTo || ""
  );

  const ref = useRef(null);

  // sync externo
  useEffect(() => {
    if (mode === "draft") {
      if (draftHourFrom !== undefined && draftHourFrom !== from) {
        setFrom(draftHourFrom || "");
      }
      if (draftHourTo !== undefined && draftHourTo !== to) {
        setTo(draftHourTo || "");
      }
    } else {
      if (hourFrom !== undefined && hourFrom !== from) {
        setFrom(hourFrom || "");
      }
      if (hourTo !== undefined && hourTo !== to) {
        setTo(hourTo || "");
      }
    }
  }, [mode, draftHourFrom, draftHourTo, hourFrom, hourTo]);

  // cerrar al click afuera
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleFromChange = (value) => {
    setFrom(value);
    if (mode === "draft" && onDraftChange) {
      onDraftChange(value, to);
    }
  };

  const handleToChange = (value) => {
    setTo(value);
    if (mode === "draft" && onDraftChange) {
      onDraftChange(from, value);
    }
  };

  const handleApply = () => {
    if (mode === "apply" && onApply) {
      onApply(from, to);
    }
    setOpen(false);
  };

  const handleClear = () => {
    if (mode === "draft") {
      setFrom("");
      setTo("");
      if (onDraftChange) {
        onDraftChange("", "");
      }
    } else {
      // modo apply → todo el día
      const fullFrom = "00:00";
      const fullTo = "23:59";
      setFrom(fullFrom);
      setTo(fullTo);
      if (onApply) {
        onApply(fullFrom, fullTo);
      }
    }
  };


  return (
    <div className="time-popover-wrapper" ref={ref}>
      <button
        type="button"
        className="time-trigger-btn"
        onClick={() => setOpen(!open)}
        title={
          mode === "draft"
            ? 'Seleccionar rango horario (aplica con "Aplicar filtros")'
            : "Seleccionar rango horario"
        }
      >
        <Clock size={14} />
        {from && to ? `${from} – ${to}` : "Horario"}
      </button>

      {open && (
        <div className="time-popover">
          <div className="time-row">
            <label>Desde</label>
            <input
              type="time"
              value={from}
              onChange={(e) => handleFromChange(e.target.value)}
            />
          </div>

          <div className="time-row">
            <label>Hasta</label>
            <input
              type="time"
              value={to}
              onChange={(e) => handleToChange(e.target.value)}
            />
          </div>

          {mode === "apply" ? (
            <div className="time-actions">
              <button
                className="btn-secondary"
                onClick={() => setOpen(false)}
              >
                Cancelar
              </button>

              <button
                className="btn-secondary"
                onClick={handleClear}
              >
                Todo el día
              </button>

              <button
                className="btn-primary"
                onClick={handleApply}
                disabled={!from || !to}
              >
                Aplicar
              </button>
            </div>
          ) : (
            <div
              style={{
                fontSize: "11px",
                color: "#666",
                marginTop: "8px",
                fontStyle: "italic",
              }}
            >
              Los cambios se aplican al hacer clic en "Aplicar"
              <div style={{ marginTop: "8px" }}>
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={handleClear}
                  style={{ fontSize: "11px", padding: "4px 8px" }}
                >
                  Limpiar horario
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TimeRangePopover;
